import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {PromoCodesService} from "../../../../+promo/services/promocodes.service";
import {IPromoCode, IPromoCodesMetadata} from "../../../../+promo/interfaces/promo-code.interface";
import {IPromoCodeReward} from "../../../../+promo/interfaces/promo-code-reward.interface";
import {PromoCodeRewardTypeEnum} from "../../../../+promo/enums";

@Component({
  selector: 'app-promo-info-modal',
  templateUrl: './promo-info-modal.component.html',
  styleUrls: ['./promo-info-modal.component.scss']
})
export class PromoInfoModalComponent implements OnInit {
  public promo: IPromoCode | null = null;
  public isLoading: boolean = true;
  public notFound: boolean = false;

  constructor(public dialogRef: MatDialogRef<PromoInfoModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { id: number },
              private promoCodesService: PromoCodesService) {
  }

  ngOnInit(): void {
    // Инфу по промокоду тянем по id через уже готовый getPromoCodes (возвращает код с наградами).
    this.promoCodesService.getPromoCodes({limit: 1, offset: 0}, {ids: [this.data.id]})
      .subscribe((res: IPromoCodesMetadata) => {
        this.promo = res?.promoCodes?.[0] || null;
        this.notFound = !this.promo;
        this.isLoading = false;
      });
  }

  close(): void {
    this.dialogRef.close();
  }

  /**
   * Универсальная стоимость награды для колонки «Reward Price».
   * Возвращает { amount, money } либо null (стоимость неизвестна → в шаблоне «-»).
   *  - free-case: суммарная цена реальных кейсов набора (Σ lastRevision.price) × количество, копейки, money=true;
   *  - item: цена инвентарного предмета × количество, копейки, money=true;
   *  - wallet / wallet-percent (и прочее): «value просто» — сырое значение, money=false.
   * money=true рисуется в шаблоне как `amount / 100 | currency`, money=false — как есть.
   */
  rewardPrice(reward: IPromoCodeReward): { amount: number; money: boolean } | null {
    const count = reward.value || 1;

    switch (reward.type) {
      case PromoCodeRewardTypeEnum.FREE_CASE: {
        if (!reward.item?.freeCases) return null;
        const setPrice = reward.item.freeCases.reduce(
          (sum, fc) => sum + (fc?.case?.lastRevision?.price || 0),
          0,
        );
        return {amount: setPrice * count, money: true};
      }
      case PromoCodeRewardTypeEnum.ITEM: {
        if (reward.item?.price == null) return null;
        return {amount: reward.item.price * count, money: true};
      }
      default:
        // wallet / wallet-percent и остальные — показываем сырое value.
        return reward.value != null ? {amount: reward.value, money: false} : null;
    }
  }
}
